<script>
  import { getContext } from "svelte";
  import { _ as t } from "svelte-i18n";
  import { Icon, Item, Badge, Popup } from "t2c-components";
  import ContextMenu from "components/ContextMenu.svelte";

  import DeleteDocument from "./DeleteDocument.svelte";
  import EditDocument from "./EditDocument.svelte";

  import { deleteDocument, updateDocument } from "./actions";

  export let document;
  export let folderId;
  export let lawcaseId;

  const basePath = `/lawcase/${lawcaseId}/document`;

  // TODO: handle only own document

  let menu;

  const { open, close } = getContext("simple-modal");
  const handleDeleteDocument = (e, document) => {
    e.preventDefault();
    e.stopPropagation();

    open(DeleteDocument, {
      onSave: () => {
        close();
      },
      onClose: () => {
        close();
      },
      action: () => deleteDocument(lawcaseId, folderId, document.id),
      title: $t("document.deleteDocument"),
      confirm: $t("document.confirmDeleteDocument"),
    });
  };

  const handleEditDocument = (e, document) => {
    e.preventDefault();
    e.stopPropagation();

    open(EditDocument, {
      onSave: () => {
        close();
      },
      onClose: () => {
        close();
      },
      action: (title, description) => {
        const params = { title, description };
        return updateDocument(lawcaseId, document.id, params);
      },
      title: $t("document.editDocument"),
      name: document.title,
      description: document.description,
    });
  };

  const documentMenu = [
    {
      icon: "edit",
      handleClick: (e) => handleEditDocument(e, document),
      text: $t("document.editDocument"),
    },
    {
      icon: "trash",
      handleClick: (e) => handleDeleteDocument(e, document),
      text: $t("document.deleteDocument"),
    },
  ];
</script>

<Item
  link={`${basePath}/${document.id}`}
  text={`${document.title}${document.fileExtension}`}
  description={document.description}
  unread={!document.hasRead}
>
  <div slot="icon" style="padding-right: 12px;">
    <Icon inline icon="handle" fill="none" stroke="#1f363d" />
  </div>
  <div slot="tag">
    <div class="tags">
      {#if !!document.clientId}
        <Badge text={$t("document.clientDocument")} />
      {/if}
    </div>
  </div>
  <div slot="actions">
    {#if document.clientId}
      {#if document.isLocked}
        <Popup content={$t("document.locked")}>
          <Icon medium icon="closed-lock" fill="#999" />
        </Popup>
      {:else}
        <ContextMenu menu={documentMenu} bind:this={menu} />
      {/if}
    {/if}
  </div>
  <div slot="stats">
    {#if document.thumbnailSource}
      <img
        class="shadow-5 thumbnail"
        width="80"
        height="80"
        src={document.thumbnailSource}
        alt="thumbnail"
      />
    {:else}
      <Icon icon="document" />
    {/if}
  </div>
</Item>

<style>
  .thumbnail {
    object-fit: cover;
    border: 1px solid #ddd;
  }

  .tags {
    margin-left: -6px;
    margin-top: 4px;
  }
</style>
